﻿(function () {

    'use strict';
    var serviceId = 'repository.stocksummary';
    angular
        .module('app.services')
        .factory(serviceId, stocksummary);

    stocksummary.$inject = ['common', 'repository.abstract', '$http'];

    function stocksummary(common, abstractRepository, $http) {
        var config = common.config;

        function Ctor(mgr) {
            this.manager = mgr;
            this.getFilters = getFilters;
            this.getCarrierList = getCarrierList;
            this.getstockSummaryList = getstockSummaryList;
            this.getstockSummaryListExcel = getstockSummaryListExcel;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getFilters() {
            var authData = common.localStorageService.get('authorizationData');
            var codeRole = authData ? authData.userRole : "";
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetContainerReceptionFilters?codeRole=' + codeRole);
        }

        function getCarrierList() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetCarrierList');
        }

        function getstockSummaryList(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/SearchResumenStock', model);
        }

        function getstockSummaryListExcel(model, fileName) {
            common.httpPostFile(config.basePaths.Base_Path_Resources + 'reportList/PrintResumenStockReport', model, fileName);
        }
    }

})();
